import React, { useState } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Link } from 'react-router-dom';
import { useAuth } from "../Components/AuthContext";
import { logoutUser } from "../Components/Authservice.ts";
import "../App.css";

const Contact = () => {
  const { user } = useAuth();
  
  return (
    <>
      {/* Navigation Header */}
      <header className="navbar">
        <div className="logo">Ani<span className="highlight">Spark</span></div>
        <nav className="nav-links">
          <Link to="/">Home</Link>
          <Link to="/explore">Explore</Link>
          <Link to="/upload">Upload</Link>
          <Link to="/about">About</Link>
          <Link to="/contact">Contact</Link>
        </nav>
        
        <div className="auth-buttons">
          {user ? (
            <>
              <span className="welcome-text">Welcome, {user.email}</span>
              <button onClick={logoutUser} className="login">Log Out</button>
            </>
          ) : (
            <>
              <Link to="/login" className="auth-button login">Login</Link>
              <Link to="/signup" className="auth-button signup">Sign Up</Link>
            </>
          )}
        </div>
      </header>

      {/* Contact Page Content */}
      <div className="contact-page">
        <div className="star-field">
          {Array.from({ length: 100 }).map((_, i) => (
            <div
              key={i}
              className="star"
              style={{
                top: `${Math.random() * 100}%`,
                left: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 3}s`
              }}
            />
          ))}
        </div>

        <Container fluid className="py-5">
          <Row className="justify-content-center">
            <Col lg={10} xl={8}>
              <div className="text-center mb-5">
                <img 
                  src="/sparkyjumpingforjoy.png"
                  alt="AniSpark Mascot" 
                  className="mascot-image mb-4"
                  style={{
                    width: '120px',
                    height: '120px',
                    filter: 'drop-shadow(0 8px 16px rgba(0,0,0,0.3))'
                  }}
                />
                <h1 className="text-light mb-3" style={{ fontSize: '3rem', fontWeight: '700' }}>
                  Contact Us
                </h1>
                <p className="text-light" style={{ fontSize: '1.2rem', opacity: 0.9 }}>
                  We'd love to hear from you! Get in touch with the AniSpark team.
                </p>
              </div>

              <Row className="g-4">
                {/* Contact Methods */}
                <Col md={4}>
                  <Card 
                    className="h-100"
                    style={{ 
                      backgroundColor: "rgba(30, 27, 75, 0.8)", 
                      border: "1px solid rgba(255, 255, 255, 0.1)",
                      borderRadius: "16px",
                      backdropFilter: "blur(10px)"
                    }}
                  >
                    <Card.Body className="p-4">
                      <h3 className="text-light mb-3" style={{ color: '#facc15', fontSize: '1.5rem', fontWeight: '600' }}>
                        Email Support
                      </h3>
                      <p className="text-light" style={{ opacity: 0.9, lineHeight: '1.7' }}>
                        For general inquiries, technical support, or creator questions:
                      </p>
                      <a 
                        href="mailto:support@anispark.co" 
                        style={{ color: '#facc15', textDecoration: 'none', fontWeight: '500' }}
                      >
                        support@anispark.co
                      </a>
                    </Card.Body>
                  </Card>
                </Col>

                <Col md={4}>
                  <Card 
                    className="h-100"
                    style={{ 
                      backgroundColor: "rgba(30, 27, 75, 0.8)", 
                      border: "1px solid rgba(255, 255, 255, 0.1)",
                      borderRadius: "16px",
                      backdropFilter: "blur(10px)"
                    }}
                  >
                    <Card.Body className="p-4">
                      <h3 className="text-light mb-3" style={{ color: '#facc15', fontSize: '1.5rem', fontWeight: '600' }}>
                        Business Inquiries
                      </h3>
                      <p className="text-light" style={{ opacity: 0.9, lineHeight: '1.7' }}>
                        For partnerships, advertising, or business-related questions:
                      </p>
                      <a 
                        href="mailto:support@anispark.co" 
                        style={{ color: '#facc15', textDecoration: 'none', fontWeight: '500' }}
                      >
                        support@anispark.co
                      </a>
                    </Card.Body>
                  </Card>
                </Col>

                <Col md={4}>
                  <Card 
                    className="h-100"
                    style={{ 
                      backgroundColor: "rgba(30, 27, 75, 0.8)", 
                      border: "1px solid rgba(255, 255, 255, 0.1)",
                      borderRadius: "16px",
                      backdropFilter: "blur(10px)"
                    }}
                  >
                    <Card.Body className="p-4">
                      <h3 className="text-light mb-3" style={{ color: '#facc15', fontSize: '1.5rem', fontWeight: '600' }}>
                        Content Issues
                      </h3>
                      <p className="text-light" style={{ opacity: 0.9, lineHeight: '1.7' }}>
                        To report inappropriate content or copyright concerns:
                      </p>
                      <a 
                        href="mailto:support@anispark.co" 
                        style={{ color: '#facc15', textDecoration: 'none', fontWeight: '500' }}
                      >
                        support@anispark.co
                      </a>
                    </Card.Body>
                  </Card>
                </Col>

                {/* Response Time & FAQ */}
                <Col md={6}>
                  <Card 
                    className="h-100"
                    style={{ 
                      backgroundColor: "rgba(30, 27, 75, 0.8)", 
                      border: "1px solid rgba(255, 255, 255, 0.1)",
                      borderRadius: "16px",
                      backdropFilter: "blur(10px)"
                    }}
                  >
                    <Card.Body className="p-4">
                      <h3 className="text-light mb-3" style={{ color: '#facc15', fontSize: '1.5rem', fontWeight: '600' }}>
                        Response Time
                      </h3>
                      <p className="text-light" style={{ opacity: 0.9, lineHeight: '1.7' }}>
                        We typically respond to inquiries within 24-48 hours during business days. 
                        For urgent technical issues, please include "URGENT" in your subject line.
                      </p>
                    </Card.Body>
                  </Card>
                </Col>

                <Col md={6}>
                  <Card 
                    className="h-100"
                    style={{ 
                      backgroundColor: "rgba(30, 27, 75, 0.8)", 
                      border: "1px solid rgba(255, 255, 255, 0.1)",
                      borderRadius: "16px",
                      backdropFilter: "blur(10px)"
                    }}
                  >
                    <Card.Body className="p-4">
                      <h3 className="text-light mb-3" style={{ color: '#facc15', fontSize: '1.5rem', fontWeight: '600' }}>
                        Quick Answers
                      </h3>
                      <p className="text-light" style={{ opacity: 0.9, lineHeight: '1.7' }}>
                        Looking for quick answers? Check out our{' '}
                        <a href="/faq" style={{ color: '#facc15', textDecoration: 'underline' }}>
                          FAQ section
                        </a>{' '}
                        for commonly asked questions about using AniSpark.
                      </p>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>

        <style jsx>{`
          /* Navigation Styles */
          .navbar {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 1rem 2rem;
            background: rgba(30, 27, 75, 0.9);
            backdrop-filter: blur(10px);
            border-bottom: 1px solid rgba(255, 255, 255, 0.1);
            position: sticky;
            top: 0;
            z-index: 1000;
          }

          .logo {
            font-size: 1.8rem;
            font-weight: 700;
            color: white;
          }

          .highlight {
            color: #facc15;
          }

          .nav-links {
            display: flex;
            gap: 2rem;
          }

          .nav-links a {
            color: white;
            text-decoration: none;
            font-weight: 500;
            transition: color 0.3s ease;
          }

          .nav-links a:hover {
            color: #facc15;
          }

          .auth-buttons {
            display: flex;
            gap: 1rem;
            align-items: center;
          }

          .welcome-text {
            color: white;
            margin-right: 1rem;
          }

          .auth-button, .login {
            padding: 0.5rem 1rem;
            border-radius: 8px;
            text-decoration: none;
            font-weight: 500;
            transition: all 0.3s ease;
            border: none;
            cursor: pointer;
          }

          .login {
            background: transparent;
            color: white;
            border: 1px solid rgba(255, 255, 255, 0.3);
          }

          .login:hover {
            background: rgba(255, 255, 255, 0.1);
          }

          .signup {
            background: #facc15;
            color: #1e1b4b;
          }

          .signup:hover {
            background: #eab308;
          }

          /* Existing page styles */
          .contact-page {
            background: linear-gradient(135deg, #1e1b4b 0%, #3c366b 100%);
            position: relative;
            overflow: hidden;
            min-height: 100vh;
          }
          
          .star-field {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            pointer-events: none;
            z-index: 1;
          }
          
          .container-fluid {
            position: relative;
            z-index: 2;
          }

          .star {
            position: absolute;
            width: 2px;
            height: 2px;
            background: white;
            border-radius: 50%;
            animation: twinkle 3s ease-in-out infinite;
          }
          
          @keyframes twinkle {
            0%, 100% { opacity: 0.3; }
            50% { opacity: 1; }
          }

          .card {
            transition: transform 0.3s ease, box-shadow 0.3s ease;
          }

          .card:hover {
            transform: translateY(-5px);
            box-shadow: 0 10px 30px rgba(0,0,0,0.3);
          }

          .mascot-image {
            animation: float 3s ease-in-out infinite;
          }

          @keyframes float {
            0%, 100% { transform: translateY(0px); }
            50% { transform: translateY(-10px); }
          }

          /* Responsive Design */
          @media (max-width: 768px) {
            .navbar {
              flex-direction: column;
              gap: 1rem;
              padding: 1rem;
            }
            
            .nav-links {
              gap: 1rem;
            }
            
            .auth-buttons {
              flex-direction: column;
              gap: 0.5rem;
            }

            h1 {
              font-size: 2rem !important;
            }
          }
        `}</style>
      </div>
    </>
  );
};

export default Contact;